import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const Container: StyleRule<{
    top: number;
}> = ({ top }) => ({
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    gap: pxToRem(8),
    padding: pxArrayToRem([9, 10]),
    backgroundColor: 'rgba(52, 52, 52, 0.30)',
    borderRadius: pxToRem(8),
    backdropFilter: 'blur(8px)',
    position: 'absolute',
    top: `${top}px`,
    left: pxToRem(105),
    zIndex: 11,

    '&::after': {
        content: '""',
        width: 0,
        height: 0,
        borderTop: `7px solid transparent`,
        borderBottom: `7px solid transparent`,
        borderRight: `7px solid rgba(52, 52, 52, 0.30)`,
        position: 'absolute',
        top: '50%',
        left: '-7px',
        transform: 'translateY(-50%)',
    },
});

export const Button: StyleRule = () => ({
    minWidth: pxToRem(110),
    height: pxToRem(30),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: pxToRem(10),
    padding: pxArrayToRem([6, 16]),
    borderRadius: pxToRem(8),
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    backgroundColor: '#f8f6f4',
    fontWeight: 500,
    color: '#000',
    whiteSpace: 'nowrap',

    '&:hover': {
        backgroundColor: '#272727',
        color: '#fff',

        '& svg': {
            color: '#fff',
        },
    },
});

export const ButtonLoader: StyleRule<{ isAddingToCart: boolean }> = ({
    isAddingToCart,
}) => ({
    padding: isAddingToCart ? pxArrayToRem([3, 16]) : pxArrayToRem([6, 16]),

    '&:hover': {
        '& > span > div > div > span > svg': {
            fill: '#fff',
        },
    },
});

export const ReplaceButtonIcon: StyleRule = () => ({
    width: pxToRem(13),
    height: pxToRem(13),

    '& > span > svg': {
        width: pxToRem(13),
        height: pxToRem(13),
    },
});

export const DeleteButton: StyleRule = () => ({
    minWidth: 'unset',
    width: pxToRem(30),
    height: pxToRem(30),
    borderRadius: '50%',
    padding: 0,
    flexShrink: 0,
});

export const DeleteButtonIcon: StyleRule = () => ({
    width: pxToRem(16),
    height: pxToRem(16),
});
